/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const FooterBase = styled.footer`
  background: var(--black);
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 15px;
  padding-bottom: 10px;
  color: var(--white);
  text-align: center;
`;
